import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import CarousselNav from "../../components/Card/CarousselNav";
import Loader from "../../components/Loader";
import MicrosoftMessage from "./MicrosoftMessage";
import MicrosoftOverview from "./MicrosoftOverview";
import ArrowSphereAll from "./ArrowSphereAll";
import ArrowSphereClient from "./ArrowSphereClient";
import ButtonArrow from "../../components/ButtonArrow";

export default function Microsoft() {
    const { user } = useContext(AuthContext);
    const [currentSlide, setCurrentSlide] = useState(0);
    const valuesType = ["Licenses Client", user.roles.includes("ROLE_SUPERADMIN") ? "Licenses All" : '', "Santé des services", "Centre de message"];

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                <div className="ecp-container-content-header">
                    <div className="ecp-container-content-header-title">
                        <div className="page-title page-logo">
                            <img src="./assets/microsoft.png" alt="Logo de Microsoft" />
                            <h1 className="page-title">Microsoft</h1>
                            <ButtonArrow url={"https://portal.office.com/"} />
                        </div>
                        <CarousselNav arrayValues={valuesType} currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} />
                    </div>
                </div>
                {currentSlide === 0 && <ArrowSphereClient />}
                {user.roles.includes("ROLE_SUPERADMIN") && currentSlide === 1 && (
                    <ArrowSphereAll />
                )}
                {currentSlide === 2 && <MicrosoftOverview />}
                {currentSlide === 3 && <MicrosoftMessage />}
            </div>
        </div>
    )
}
